<template>
  <v-dialog v-model="aberto" persistent max-width="440">
    <v-card>
      <v-card-title class="text-h6" style="word-break: normal;">
        {{ titulo }}
      </v-card-title>

      <v-card-text>
        <p class="mb-4">{{ mensagem }}</p>
        <div class="text-center">
          <div class="text-h3" style="color: #F59E0B; font-weight: bold;">{{ contagem }}</div>
          <div class="text-caption">segundos</div>
        </div>
      </v-card-text>

      <v-card-actions class="pb-4 px-4">
        <v-btn text small @click="sair">Sair agora</v-btn>
        <v-spacer />
        <!--
          No encerramento por teto de sessao nao ha o que continuar: nenhuma
          interacao adia as 3 horas. Oferecer o botao seria mentir - ele
          reabriria o aviso no tick seguinte.
        -->
        <!--
          Verde, e nao o azul da marca: o dialogo aparece com um contador
          ambar piscando urgencia, e o azul do portal e a cor de tudo que e
          cromo (cabecalho, menu, botoes comuns) - o botao se perdia no meio.
          O verde e a unica cor da paleta que nao compete nem com o alerta nem
          com o cromo, e ja e usada no portal para acao positiva.

          "Sair agora" foi para a esquerda, pequeno e sem preenchimento: as
          duas acoes disputavam o mesmo canto, e a destrutiva estava colada na
          construtiva.
        -->
        <v-btn
          v-if="podeContinuar"
          color="#16A34A"
          dark
          large
          elevation="4"
          class="px-8 font-weight-bold"
          @click="continuar"
        >
          <v-icon left>mdi-check-circle</v-icon>
          Continuar conectado
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { estadoSessao, continuarConectado, encerrarSessao } from '../plugins/sessao'

export default {
  name: 'SessaoExpirandoDialog',
  computed: {
    aberto() {
      return estadoSessao.avisando
    },
    contagem() {
      return estadoSessao.segundos
    },
    podeContinuar() {
      return estadoSessao.motivo !== 'teto'
    },
    titulo() {
      return this.podeContinuar ? 'Sua sessão vai expirar' : 'Sua sessão chegou ao limite'
    },
    mensagem() {
      return this.podeContinuar
        ? 'Você está sem atividade há algum tempo e será desconectado por segurança.'
        : 'Por segurança, a sessão tem duração máxima de 3 horas. Faça login novamente para continuar.'
    }
  },
  methods: {
    continuar() {
      continuarConectado()
    },
    sair() {
      encerrarSessao('manual')
    }
  }
}
</script>
